module.exports = __webpack_public_path__ + "static/dt-9c8ae7f704ed6500c5c7a3eb4972e5bb.svg";